import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';

export const inventorySessionAPI = createApi({
    reducerPath: 'inventorySessionAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    endpoints: (builder) => ({
        exportBoxesCsv: builder.query<Blob, { clientId: number; orderBy?: string; searchTerm?: string; filters?: Record<string, unknown> }>({
            query: ({ clientId, orderBy, searchTerm, filters }) => ({
                url: 'InventorySession/boxes/export',
                method: 'GET',
                params: {
                    clientId,
                    orderBy,
                    searchTerm,
                    filters: filters ? JSON.stringify(filters) : undefined
                },
                responseType: 'blob'
            })
        }),
    }),
});

export const {
    useLazyExportBoxesCsvQuery,
} = inventorySessionAPI;
